<template>
  <el-container class="vipOrders">
    <el-header class="header-style">
      <el-divider content-position="left">客户会员订单列表</el-divider>
      <el-row>
        <el-col :span="24">
          <el-input
            style="width: auto"
            v-model="searchArr.out_trade_no"
            size="mini"
            placeholder="输入订单号筛选"
            @input="handleOutTradeNoChange"
          ></el-input>
          <el-popover placement="bottom-start" v-model="visible" width="320">
            <el-form :model="searchArr" ref="searchForm" label-width="100px">
              <el-form-item label="所属业务" prop="salesman_id">
                <el-cascader
                  style="width: 200px"
                  v-model="searchArr.salesman_id"
                  placeholder="请选择所属业务"
                  :options="adminUsers"
                  size="mini"
                  :props="{ expandTrigger: 'hover' }"
                  clearable
                  filterable
                  :filter-method="filterOptions"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="支付人/手机号" prop="payuser_id">
                <el-input
                  v-model="searchArr.payuser_id"
                  size="mini"
                  placeholder="支付人 / 手机号"
                ></el-input>
              </el-form-item>
              <el-form-item style="text-align: right">
                <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
                <el-button type="primary" @click="submitForm('searchForm')" size="mini"
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
            <el-button slot="reference" size="mini">筛选</el-button>
          </el-popover>
        </el-col>
      </el-row>
    </el-header>

    <el-main class="main-style">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 已完成订单模块 开始-->
        <el-tab-pane label="支付成功" name="SUCCESS">
          <el-table
            height="calc(100vh - 346px)"
            :data="pageData"
            size="mini"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="订单号" width="200" fixed>
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  v-if="scope.row.payer && scope.row.payer.user"
                  :underline="false"
                  style="padding: 0; border: none"
                  slot="reference"
                  @click="handleShowCommodity(scope.row, scope.row.payer.user)"
                  >{{ scope.row.out_trade_no }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column label="会员名称">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.description" placement="top">
                  <span class="hide-style">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="支付人" prop="out_trade_no">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.name"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone" width="130">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.phone"
                  placement="top"
                >
                  <span class="hide-style"
                    ><el-link
                      style="color: #409eff; cursor: pointer"
                      @click="openPhoneFromDraw(scope.row.payer.user.phone)"
                      >{{ scope.row.payer.user.phone }}</el-link
                    >
                    <el-tooltip effect="drak" content="电话外呼" placement="bottom">
                      <i
                        @click="makePhone(scope.row.payer.user.phone)"
                        class="el-icon-phone-outline"
                        style="color: #409eff; cursor: pointer"
                      ></i>
                    </el-tooltip>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="是否线索">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.publicthread && scope.row.publicthread.admin === null"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip content="未认领" placement="top">
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <el-link
                  v-else-if="scope.row.publicthread && scope.row.publicthread.admin"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip
                    :content="scope.row.publicthread.admin.username"
                    placement="top"
                  >
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <span v-else class="hide-style" content="否">否</span>
              </template>
            </el-table-column>
            <el-table-column
              label="下单业务"
              :render-header="downOrderrenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.salesman"
                  :content="scope.row.salesman.username"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.salesman.username }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="当前业务"
              :render-header="currentRenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="
                    scope.row.payer &&
                    scope.row.payer.user &&
                    scope.row.payer.user.business
                  "
                  :content="scope.row.payer.user.business.username"
                  placement="top"
                >
                  <span class="hide-style">{{
                    scope.row.payer.user.business.username
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="total">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.trade_state === '未支付'"
                  type="primary"
                  style="padding: 0; border: 0"
                  slot="reference"
                  @click="handleUpTotal(scope.row)"
                  >{{ scope.row.total }}</el-link
                >
                <span v-else>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="货币类型" prop="currency"></el-table-column>
            <el-table-column label="交易状态" prop="trade_state"></el-table-column>
            <el-table-column label="支付时间" prop="success_time">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.success_time" placement="top">
                  <span class="hide-style">{{ scope.row.success_time }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.created_at" placement="top">
                  <span class="hide-style">{{ scope.row.created_at }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="退款状态" prop="refund_status">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.refund_status" placement="top">
                  <span class="hide-style">{{ scope.row.refund_status }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="退款" placement="top">
                  <el-button
                    v-if="
                      scope.row.trade_state === '支付成功' && !scope.row.refund_status
                    "
                    type="danger"
                    size="mini"
                    icon="el-icon-refresh-left"
                    circle
                    @click="handRefund(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 已完成订单模块 结束-->
        <!-- 未完成订单模块 开始-->
        <el-tab-pane label="未支付" name="NOTPAY">
          <el-table
            height="calc(100vh - 346px)"
            :data="pageData"
            size="mini"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="订单号" width="200" fixed>
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  v-if="scope.row.payer && scope.row.payer.user"
                  :underline="false"
                  style="padding: 0; border: none"
                  slot="reference"
                  @click="handleShowCommodity(scope.row, scope.row.payer.user)"
                  >{{ scope.row.out_trade_no }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column label="会员名称">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.description" placement="top">
                  <span class="hide-style">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="支付人" prop="out_trade_no">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.name"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone" width="130">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.phone"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.phone }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="是否线索">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.publicthread && scope.row.publicthread.admin === null"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip content="未认领" placement="top">
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <el-link
                  v-else-if="scope.row.publicthread && scope.row.publicthread.admin"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip
                    :content="scope.row.publicthread.admin.username"
                    placement="top"
                  >
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <span v-else class="hide-style" content="否">否</span>
              </template>
            </el-table-column>
            <el-table-column
              label="下单业务"
              :render-header="downOrderrenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.salesman"
                  :content="scope.row.salesman.username"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.salesman.username }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="当前业务"
              :render-header="currentRenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="
                    scope.row.payer &&
                    scope.row.payer.user &&
                    scope.row.payer.user.business
                  "
                  :content="scope.row.payer.user.business.username"
                  placement="top"
                >
                  <span class="hide-style">{{
                    scope.row.payer.user.business.username
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="total">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.trade_state === '未支付'"
                  type="primary"
                  style="padding: 0; border: 0"
                  slot="reference"
                  @click="handleUpTotal(scope.row)"
                  >{{ scope.row.total }}</el-link
                >
                <span v-else>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="货币类型" prop="currency"></el-table-column>
            <el-table-column label="交易状态" prop="trade_state"></el-table-column>
            <el-table-column label="支付时间" prop="success_time">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.success_time" placement="top">
                  <span class="hide-style">{{ scope.row.success_time }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.created_at" placement="top">
                  <span class="hide-style">{{ scope.row.created_at }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="退款状态" prop="refund_status">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.refund_status" placement="top">
                  <span class="hide-style">{{ scope.row.refund_status }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="退款" placement="top">
                  <el-button
                    v-if="
                      scope.row.trade_state === '支付成功' && !scope.row.refund_status
                    "
                    type="danger"
                    size="mini"
                    icon="el-icon-refresh-left"
                    circle
                    @click="handRefund(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 未完成订单模块 结束-->
        <!-- 用户支付中订单模块 开始-->
        <el-tab-pane label="用户支付中" name="USERPAYING">
          <el-table
            height="calc(100vh - 346px)"
            :data="pageData"
            size="mini"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="订单号" width="200" fixed>
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  v-if="scope.row.payer && scope.row.payer.user"
                  :underline="false"
                  style="padding: 0; border: none"
                  slot="reference"
                  @click="handleShowCommodity(scope.row, scope.row.payer.user)"
                  >{{ scope.row.out_trade_no }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column label="会员名称">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.description" placement="top">
                  <span class="hide-style">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="支付人" prop="out_trade_no">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.name"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone" width="130">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.phone"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.phone }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="是否线索">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.publicthread && scope.row.publicthread.admin === null"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip content="未认领" placement="top">
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <el-link
                  v-else-if="scope.row.publicthread && scope.row.publicthread.admin"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip
                    :content="scope.row.publicthread.admin.username"
                    placement="top"
                  >
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <span v-else class="hide-style" content="否">否</span>
              </template>
            </el-table-column>
            <el-table-column
              label="下单业务"
              :render-header="downOrderrenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.salesman"
                  :content="scope.row.salesman.username"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.salesman.username }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="当前业务"
              :render-header="currentRenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="
                    scope.row.payer &&
                    scope.row.payer.user &&
                    scope.row.payer.user.business
                  "
                  :content="scope.row.payer.user.business.username"
                  placement="top"
                >
                  <span class="hide-style">{{
                    scope.row.payer.user.business.username
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="total">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.trade_state === '未支付'"
                  type="primary"
                  style="padding: 0; border: 0"
                  slot="reference"
                  @click="handleUpTotal(scope.row)"
                  >{{ scope.row.total }}</el-link
                >
                <span v-else>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="货币类型" prop="currency"></el-table-column>
            <el-table-column label="交易状态" prop="trade_state"></el-table-column>
            <el-table-column label="支付时间" prop="success_time">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.success_time" placement="top">
                  <span class="hide-style">{{ scope.row.success_time }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.created_at" placement="top">
                  <span class="hide-style">{{ scope.row.created_at }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="退款状态" prop="refund_status">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.refund_status" placement="top">
                  <span class="hide-style">{{ scope.row.refund_status }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="退款" placement="top">
                  <el-button
                    v-if="
                      scope.row.trade_state === '支付成功' && !scope.row.refund_status
                    "
                    type="danger"
                    size="mini"
                    icon="el-icon-refresh-left"
                    circle
                    @click="handRefund(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 用户支付中订单模块 结束-->
        <!-- 用户支付失败订单模块 开始-->
        <el-tab-pane label="支付失败" name="PAYERROR">
          <el-table
            height="calc(100vh - 346px)"
            :data="pageData"
            size="mini"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="订单号" width="200" fixed>
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  v-if="scope.row.payer && scope.row.payer.user"
                  :underline="false"
                  style="padding: 0; border: none"
                  slot="reference"
                  @click="handleShowCommodity(scope.row, scope.row.payer.user)"
                  >{{ scope.row.out_trade_no }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column label="会员名称">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.description" placement="top">
                  <span class="hide-style">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="支付人" prop="out_trade_no">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.name"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone" width="130">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.phone"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.phone }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="是否线索">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.publicthread && scope.row.publicthread.admin === null"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip content="未认领" placement="top">
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <el-link
                  v-else-if="scope.row.publicthread && scope.row.publicthread.admin"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip
                    :content="scope.row.publicthread.admin.username"
                    placement="top"
                  >
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <span v-else class="hide-style" content="否">否</span>
              </template>
            </el-table-column>
            <el-table-column
              label="下单业务"
              :render-header="downOrderrenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.salesman"
                  :content="scope.row.salesman.username"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.salesman.username }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="当前业务"
              :render-header="currentRenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="
                    scope.row.payer &&
                    scope.row.payer.user &&
                    scope.row.payer.user.business
                  "
                  :content="scope.row.payer.user.business.username"
                  placement="top"
                >
                  <span class="hide-style">{{
                    scope.row.payer.user.business.username
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="total">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.trade_state === '未支付'"
                  type="primary"
                  style="padding: 0; border: 0"
                  slot="reference"
                  @click="handleUpTotal(scope.row)"
                  >{{ scope.row.total }}</el-link
                >
                <span v-else>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="货币类型" prop="currency"></el-table-column>
            <el-table-column label="交易状态" prop="trade_state"></el-table-column>
            <el-table-column label="支付时间" prop="success_time">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.success_time" placement="top">
                  <span class="hide-style">{{ scope.row.success_time }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.created_at" placement="top">
                  <span class="hide-style">{{ scope.row.created_at }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="退款状态" prop="refund_status">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.refund_status" placement="top">
                  <span class="hide-style">{{ scope.row.refund_status }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="退款" placement="top">
                  <el-button
                    v-if="
                      scope.row.trade_state === '支付成功' && !scope.row.refund_status
                    "
                    type="danger"
                    size="mini"
                    icon="el-icon-refresh-left"
                    circle
                    @click="handRefund(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 用户支付失败订单模块 结束-->
        <!-- 用户支付已关闭订单模块 开始-->
        <el-tab-pane label="已关闭" name="CLOSED">
          <el-table
            height="calc(100vh - 346px)"
            :data="pageData"
            size="mini"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="订单号" width="200" fixed>
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  v-if="scope.row.payer && scope.row.payer.user"
                  :underline="false"
                  style="padding: 0; border: none"
                  slot="reference"
                  @click="handleShowCommodity(scope.row, scope.row.payer.user)"
                  >{{ scope.row.out_trade_no }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column label="会员名称">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.description" placement="top">
                  <span class="hide-style">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="支付人" prop="out_trade_no">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.name"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone" width="130">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.phone"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.phone }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="是否线索">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.publicthread && scope.row.publicthread.admin === null"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip content="未认领" placement="top">
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <el-link
                  v-else-if="scope.row.publicthread && scope.row.publicthread.admin"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip
                    :content="scope.row.publicthread.admin.username"
                    placement="top"
                  >
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <span v-else class="hide-style" content="否">否</span>
              </template>
            </el-table-column>
            <el-table-column
              label="下单业务"
              :render-header="downOrderrenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.salesman"
                  :content="scope.row.salesman.username"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.salesman.username }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="当前业务"
              :render-header="currentRenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="
                    scope.row.payer &&
                    scope.row.payer.user &&
                    scope.row.payer.user.business
                  "
                  :content="scope.row.payer.user.business.username"
                  placement="top"
                >
                  <span class="hide-style">{{
                    scope.row.payer.user.business.username
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="total">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.trade_state === '未支付'"
                  type="primary"
                  style="padding: 0; border: 0"
                  slot="reference"
                  @click="handleUpTotal(scope.row)"
                  >{{ scope.row.total }}</el-link
                >
                <span v-else>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="货币类型" prop="currency"></el-table-column>
            <el-table-column label="交易状态" prop="trade_state"></el-table-column>
            <el-table-column label="支付时间" prop="success_time">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.success_time" placement="top">
                  <span class="hide-style">{{ scope.row.success_time }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.created_at" placement="top">
                  <span class="hide-style">{{ scope.row.created_at }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="退款状态" prop="refund_status">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.refund_status" placement="top">
                  <span class="hide-style">{{ scope.row.refund_status }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="退款" placement="top">
                  <el-button
                    v-if="
                      scope.row.trade_state === '支付成功' && !scope.row.refund_status
                    "
                    type="danger"
                    size="mini"
                    icon="el-icon-refresh-left"
                    circle
                    @click="handRefund(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 用户支付已关闭订单模块 结束-->
        <!-- 用户支付已撤销订单模块 开始-->
        <el-tab-pane label="已撤销" name="REVOKED">
          <el-table
            height="calc(100vh - 346px)"
            :data="pageData"
            size="mini"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="订单号" width="200" fixed>
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  v-if="scope.row.payer && scope.row.payer.user"
                  :underline="false"
                  style="padding: 0; border: none"
                  slot="reference"
                  @click="handleShowCommodity(scope.row, scope.row.payer.user)"
                  >{{ scope.row.out_trade_no }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column label="会员名称">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.description" placement="top">
                  <span class="hide-style">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="支付人" prop="out_trade_no">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.name"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone" width="130">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.phone"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.phone }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="是否线索">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.publicthread && scope.row.publicthread.admin === null"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip content="未认领" placement="top">
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <el-link
                  v-else-if="scope.row.publicthread && scope.row.publicthread.admin"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip
                    :content="scope.row.publicthread.admin.username"
                    placement="top"
                  >
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <span v-else class="hide-style" content="否">否</span>
              </template>
            </el-table-column>
            <el-table-column
              label="下单业务"
              :render-header="downOrderrenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.salesman"
                  :content="scope.row.salesman.username"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.salesman.username }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="当前业务"
              :render-header="currentRenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="
                    scope.row.payer &&
                    scope.row.payer.user &&
                    scope.row.payer.user.business
                  "
                  :content="scope.row.payer.user.business.username"
                  placement="top"
                >
                  <span class="hide-style">{{
                    scope.row.payer.user.business.username
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="total">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.trade_state === '未支付'"
                  type="primary"
                  style="padding: 0; border: 0"
                  slot="reference"
                  @click="handleUpTotal(scope.row)"
                  >{{ scope.row.total }}</el-link
                >
                <span v-else>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="货币类型" prop="currency"></el-table-column>
            <el-table-column label="交易状态" prop="trade_state"></el-table-column>
            <el-table-column label="支付时间" prop="success_time">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.success_time" placement="top">
                  <span class="hide-style">{{ scope.row.success_time }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.created_at" placement="top">
                  <span class="hide-style">{{ scope.row.created_at }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="退款状态" prop="refund_status">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.refund_status" placement="top">
                  <span class="hide-style">{{ scope.row.refund_status }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="退款" placement="top">
                  <el-button
                    v-if="
                      scope.row.trade_state === '支付成功' && !scope.row.refund_status
                    "
                    type="danger"
                    size="mini"
                    icon="el-icon-refresh-left"
                    circle
                    @click="handRefund(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 用户支付已撤销订单模块 结束-->
        <!-- 用户支付转入退款订单模块 开始-->
        <el-tab-pane label="转入退款" name="REFUND">
          <el-table
            height="calc(100vh - 346px)"
            :data="pageData"
            size="mini"
            border
            style="width: 100%; margin-top: 0.2rem"
            v-cloak
          >
            <el-table-column label="订单号" width="200" fixed>
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  v-if="scope.row.payer && scope.row.payer.user"
                  :underline="false"
                  style="padding: 0; border: none"
                  slot="reference"
                  @click="handleShowCommodity(scope.row, scope.row.payer.user)"
                  >{{ scope.row.out_trade_no }}</el-link
                >
              </template>
            </el-table-column>
            <el-table-column label="会员名称">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.description" placement="top">
                  <span class="hide-style">{{ scope.row.description }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="支付人" prop="out_trade_no">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.name"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.name }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="手机号" prop="phone" width="130">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.payer && scope.row.payer.user"
                  :content="scope.row.payer.user.phone"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.payer.user.phone }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="是否线索">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.publicthread && scope.row.publicthread.admin === null"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip content="未认领" placement="top">
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <el-link
                  v-else-if="scope.row.publicthread && scope.row.publicthread.admin"
                  type="primary"
                  :underline="false"
                  style="padding: 0; border: none; color: #409eff"
                  slot="reference"
                  @click="handleShowChatRecordOpen(scope.row.publicthread.thread_id)"
                >
                  <el-tooltip
                    :content="scope.row.publicthread.admin.username"
                    placement="top"
                  >
                    <span class="hide-style" content="是">是</span>
                  </el-tooltip>
                </el-link>
                <span v-else class="hide-style" content="否">否</span>
              </template>
            </el-table-column>
            <el-table-column
              label="下单业务"
              :render-header="downOrderrenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.salesman"
                  :content="scope.row.salesman.username"
                  placement="top"
                >
                  <span class="hide-style">{{ scope.row.salesman.username }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="当前业务"
              :render-header="currentRenderHeader"
              width="100"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="
                    scope.row.payer &&
                    scope.row.payer.user &&
                    scope.row.payer.user.business
                  "
                  :content="scope.row.payer.user.business.username"
                  placement="top"
                >
                  <span class="hide-style">{{
                    scope.row.payer.user.business.username
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="total">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.trade_state === '未支付'"
                  type="primary"
                  style="padding: 0; border: 0"
                  slot="reference"
                  @click="handleUpTotal(scope.row)"
                  >{{ scope.row.total }}</el-link
                >
                <span v-else>{{ scope.row.total }}</span>
              </template>
            </el-table-column>
            <el-table-column label="货币类型" prop="currency"></el-table-column>
            <el-table-column label="交易状态" prop="trade_state"></el-table-column>
            <el-table-column label="支付时间" prop="success_time">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.success_time" placement="top">
                  <span class="hide-style">{{ scope.row.success_time }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="created_at">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.created_at" placement="top">
                  <span class="hide-style">{{ scope.row.created_at }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="退款状态" prop="refund_status">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.refund_status" placement="top">
                  <span class="hide-style">{{ scope.row.refund_status }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="退款" placement="top">
                  <el-button
                    v-if="
                      scope.row.trade_state === '支付成功' && !scope.row.refund_status
                    "
                    type="danger"
                    size="mini"
                    icon="el-icon-refresh-left"
                    circle
                    @click="handRefund(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- 用户支付转入退款订单模块 结束-->
      </el-tabs>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination
        class="tr mt-10"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :hide-on-single-page="false"
        :current-page.sync="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageOption.total"
        background
      >
      </el-pagination>
    </el-footer>

    <el-dialog
      title="修改金额"
      :visible.sync="totalVisible"
      width="40%"
      :before-close="handleTotalClose"
    >
      <div>
        <el-input v-model="changeTotal" size="mini"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handleTotalSub">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      title="订单详情"
      :visible.sync="handleRecordDrawer"
      direction="rtl"
      size="40%"
    >
      <div
        class="popoverList"
        style="margin-bottom: 0.4rem; padding: 0px 0.2rem 0px 0.4rem"
      >
        <p style="margin-bottom: 0.2rem">订单号：{{ payer.user_trade_no }}</p>
      </div>
      <el-divider></el-divider>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <div class="tabs_line">
          <h3 class="tabs-title">商品信息</h3>
        </div>
        <div class="popoverList" style="margin-top: 0.4rem">
          <p
            v-for="(service, index) in services"
            :key="index"
            style="margin-bottom: 0.2rem"
          >
            {{ service.name }} ——
            <span v-if="service.type !== '其他服务'">{{ service.price }}</span>
            <span v-if="service.type === '代理记账'"> —— {{ service.cycle_type }}</span>
          </p>
          <p v-if="remark" style="margin-top: 0.2rem">备注：{{ remark }}</p>
        </div>
        <el-divider></el-divider>
        <div class="tabs_line">
          <h3 class="tabs-title">支付人信息</h3>
        </div>
        <div class="popoverList" style="margin-top: 0.4rem">
          <p style="margin-bottom: 0.2rem">姓名：{{ payer.nickname }}</p>
          <p style="margin-bottom: 0.2rem">昵称：{{ payer.name }}</p>
          <p style="margin-bottom: 0.2rem">手机号：{{ payer.phone }}</p>
          <p>性别：{{ payer.sex }}</p>
        </div>
        <el-divider></el-divider>
        <div class="tabs_line">
          <h3 class="tabs-title">操作记录</h3>
        </div>
        <el-table
          :data="handRecordData"
          size="medium"
          style="width: 100%; margin-top: 0.2rem"
          v-cloak
        >
          <el-table-column
            label="操作人"
            prop="adminuser.username"
            width="100"
          ></el-table-column>
          <el-table-column label="内容" prop="content"></el-table-column>
          <el-table-column label="操作时间" prop="created_at"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 开始-->
    <el-drawer
      title="沟通记录"
      :visible.sync="chatRecordDrawer"
      direction="rtl"
      :before-close="handleChatRecordBeforeClose"
      size="40%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 结束-->
    <el-drawer
      title=""
      :visible.sync="phoneFromDraw"
      direction="rtl"
      :before-close="closePhoneFromDraw"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import ChatRecord from "common/ChatRecord";
import MakePhone from "common/MakePhone";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "vipOrders",
  components: {
    ChatRecord,
    MakePhone,
  },
  data() {
    return {
      phoneFrom_phone: [],
      phoneFromDraw: false,
      // 选项卡初始化默认值
      activeName: "SUCCESS",
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
      outTradeNo: false,
      handleRecordDrawer: false,
      handRecordData: [], // 初始化操作记录
      visible: false,
      adminUsers: [],
      searchArr: {
        out_trade_no: "",
        salesman_id: "",
        trade_state: "SUCCESS",
        refund_status: "",
        // 支付人信息
        payuser_id: "",
      },
      services: [],
      remark: "",
      payer: {
        nickname: "",
        name: "",
        phone: "",
        sex: "",
        user_trade_no: "",
      },
      totalVisible: false,
      changeTotalId: "",
      changeTotal: 0,
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
    };
  },
  computed: {
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone);
      });
      this.phoneFromDraw = true;
    },
    makePhone(phone) {
      // let regPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      // if (!regPhone.test(phone)) {
      //   this.$message.error('手机号格式错误')
      //   return
      // }

      // this.$axios.post('/api/admin/call_logs/' + phone).then(res => {
      this.$axios
        .post("api/admin/call_logs_call", {
          phone,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success("调用成功，请注意接听来电");
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = [];
      done();
    },
    getPageData() {
      this.$axios
        .get(
          "/api/admin/vip_orders?page=" +
            this.pageOption.currentPage +
            "&pageSize=" +
            this.pageOption.pageSize +
            this.searchStr
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.pageData = data.data.pageData.data;
            this.pageOption.total = data.data.pageData.total;
            this.adminUsers = data.data.adminUsers;
            this.outTradeNo = false;
          }
        });
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true;
      setTimeout(() => {
        this.threadId = threadId;
      });
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false;
      this.threadId = null;
      done();
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageData();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageData();
    },
    filterOptions(node, keyword) {
  return filterKeywordOptions(node, keyword);
},
    handleShowCommodity(row, user) {
      this.$axios.post("/api/admin/vip_orders/services", { id: row.oid }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.services = data.data.services;
          this.remark = row.remark;
          this.payer.name = user.name;
          this.payer.nickname = user.nickname;
          this.payer.user_trade_no = row.out_trade_no;
          this.payer.phone = user.phone;
          this.payer.sex = user.sex;
          this.handRecordData = data.data.handleRecords;
        } else {
          this.$message.error(data.msg);
        }
      });
      this.handleRecordDrawer = true;
    },
    handleOutTradeNoChange(val) {
      if (this.outTradeNo) return;
      this.outTradeNo = true;
      setTimeout(() => {
        this.pageOption.currentPage = 1;
        this.getPageData();
      }, 800);
    },
    resetForm(formName) {
      this.visible = false;
      this.$refs[formName].resetFields();
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    submitForm(formName) {
      this.visible = false;
      this.pageOption.currentPage = 1;
      this.getPageData();
    },
    handleUpTotal(row) {
      this.changeTotalId = row.oid;
      this.changeTotal = row.total;
      this.totalVisible = true;
    },
    handleTotalClose(done) {
      this.changeTotalId = "";
      this.changeTotal = 0;
      done();
    },
    handleTotalSub() {
      if (!this.changeTotal) {
        this.$message.error("金额不能为空");
        return;
      }
      this.$axios
        .post("/api/admin/vip_orders/change_total", {
          total: this.changeTotal,
          id: this.changeTotalId,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.getPageData();
            this.totalVisible = false;
            this.changeTotalId = "";
            this.changeTotal = 0;
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handRefund(row) {
      this.$confirm("是否确定退款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios.post("/api/admin/vip_orders/refund/" + row.oid).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.getPageData();
              this.$message.success(data.msg);
            } else {
              this.$message.error(data.msg);
            }
          });
        })
        .catch(() => {});
    },
    downOrderrenderHeader(h, { column, $index }) {
      return [
        column.label,
        h(
          "el-tooltip",
          {
            props: {
              content: (function () {
                return "指客户下单时对接的业务人员";
              })(),
              placement: "top",
            },
          },
          [
            h("span", {
              class: {
                "el-icon-question": true,
              },
            }),
          ]
        ),
      ];
    },
    currentRenderHeader(h, { column, $index }) {
      return [
        column.label,
        h(
          "el-tooltip",
          {
            props: {
              content: (function () {
                return "指当前客户对接的业务人员";
              })(),
              placement: "top",
            },
          },
          [
            h("span", {
              class: {
                "el-icon-question": true,
              },
            }),
          ]
        ),
      ];
    },
    // 选项卡默认点击事件
    handleClick(tab, event) {
      // 监听点击事件
      if (parseInt(tab.index) === 0) {
        // 成功的订单
        this.searchArr.trade_state = "SUCCESS";
        this.pageOption.currentPage = 1;
        this.getPageData();
      } else if (parseInt(tab.index) === 1) {
        // 待支付的订单
        this.searchArr.trade_state = "NOTPAY";
        this.pageOption.currentPage = 1;
        this.getPageData();
      } else if (parseInt(tab.index) === 2) {
        // 支付中的订单
        this.searchArr.trade_state = "USERPAYING";
        this.pageOption.currentPage = 1;
        this.getPageData();
      } else if (parseInt(tab.index) === 3) {
        // 支付失败的订单
        this.searchArr.trade_state = "PAYERROR";
        this.pageOption.currentPage = 1;
        this.getPageData();
      } else if (parseInt(tab.index) === 4) {
        // 已关闭的订单
        this.searchArr.trade_state = "CLOSED";
        this.pageOption.currentPage = 1;
        this.getPageData();
      } else if (parseInt(tab.index) === 5) {
        // 已撤销的订单
        this.searchArr.trade_state = "REVOKED";
        this.pageOption.currentPage = 1;
        this.getPageData();
      } else if (parseInt(tab.index) === 6) {
        // 转入退款的订单
        this.searchArr.trade_state = "REFUND";
        this.pageOption.currentPage = 1;
        this.getPageData();
      }
    },
  },
  mounted() {
    this.getPageData();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-form .el-select
  width: 100%
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-drawer .el-form-item
  margin-bottom: .3rem !important
.el-form-item
  margin-bottom: .1rem
.vipOrders
  marginLeft()
  max-height: 100vh;
  .header-style
    height: 100px !important;
    padding: 0px !important;
  .main-style
    padding: 0px !important;
    // overflow-y: auto;

  .footer-style
    text-align: right;
    // background-color: #f5f5f5;
    .el-pagination
      padding-top: 15px;

  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
  .tr
    text-align: right
  .mt-10
    margin-top: .2rem
</style>



// WEBPACK FOOTER //
// src/pages/vip_orders/vip_orders.vue